/**
 * Created by mh on 2017/5/23.
 */
import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { observer, inject } from 'mobx-react';
import AssetModel from './model/AssetModel';
import AssetVisualPreview from './AssetVisualPreview';

const TypeToColorClass = (type) => {
    switch (type) {
    case 'active':
        return 'badge-success';
    default:
        return 'badge-default';
    }
};
const TypeBadge = type => <span className={`badge ${TypeToColorClass(type)}`}>{type}</span>;

const StatusToColorClass = (type) => {
    switch (type) {
    case 'online':
        return 'badge-success';
    default:
        return 'badge-default';
    }
};
const StatusBadge = type => <span className={`badge ${StatusToColorClass(type)}`}>{type}</span>;

const BytesToSize = (bytes) => {
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    if (bytes === 0) return '0 Byte';
    const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
    return `${Math.round(bytes / (1024 ** i), 2)} ${sizes[i]}`;
};

const locationLine = (asset, location, index) => (
    <tr key={index}>
        <td className="align-middle" rowSpan={2}>
            <AssetVisualPreview asset={asset} previewStill location={location} width={80} />
        </td>
        <td className="align-middle" colSpan={7}>{location.dmrn}</td>
    </tr>
);
const detailLine = (asset, location, index) => (
    <tr key={`${index}-bline`}>
        <td className="align-middle">{TypeBadge(location.type)}</td>
        <td className="align-middle">{StatusBadge(location.status)}</td>
        <td className="align-middle">{location.mimeType}</td>
        <td className="align-middle">{location.profileKey}</td>
        <td className="align-middle">{BytesToSize(location.size)}</td>
        <td className="align-middle">{location.created}</td>
        <td className="align-middle">{location.modified}</td>
    </tr>
);

const AssetLocationRows = (asset) => {
    if (!asset) {
        return null;
    }
    const result = [];
    asset.locations.map((location, index) => {
        result.push(locationLine(asset, location, index));
        result.push(detailLine(asset, location, index));
        return result;
    });
    return result;
};

@inject('auth') @observer
class AssetLocations extends Component {
    render() {
        const { asset } = this.props;
        // Only display if any
        if (asset.locations && asset.locations.length > 0) {
            return (
                <section>
                    <h4>
                        <FormattedMessage id="Assets.Locations" defaultMessage="Locations" />
                    </h4>

                    <table className="table table-sm table-responsive table-delivermedia">
                        <tbody>
                            {AssetLocationRows(asset)}
                        </tbody>
                    </table>

                </section>
            );
        }
        return null;
    }
}

AssetLocations.propTypes = {
    asset: PropTypes.instanceOf(AssetModel).isRequired,
};

export default injectIntl(AssetLocations);
